///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/collection-category.ts"/>

module Meevo.Components.Controls.SmartMover {
    import MembershipType = Model.MembershipType;
    import Membership = Model.Membership;

    export class MembershipToMembershipType implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<MembershipType>, public child: ICollectionBase<Membership>) {
        }

        populate(): void {
            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<MembershipType>>category).resetModels(
                    this.child.models.filter((membership) => membership.get('membershipTypeId') === category.get('id'))
                );
            }
        }
    }
}
